module.exports = __webpack_public_path__ + "img/LEAD Innovation Logo.fef3d3e1.png";